import swal from "sweetalert";
import http_service from "../classes/http";
import { bus } from '../other/bus'
import { addItem, deleteItem } from '../other/methods/list_actions'

let http = new http_service(bus);
export default {
  namespaced: true,
  state: {
    classes: [],
    students: [],
    teacherHomework: [],
    teacherTemplates: [],
  },
  mutations: {
    setClasses(state, items) {
      state.classes = items;
    },
    setStudents(state, items){
      state.students = items;
    },
    setTeacherHomework(state, items){
      state.teacherHomework = items;
    },
    setTeacherTemplates(state, items){
      state.teacherTemplates = items;
    },
    addClass(state, item) {
      let sameItem = state.classes.find(cl => cl.id === item.id)

      !sameItem ? state.classes.unshift(item)
                : state.classes = state.classes.map(cl => cl.id === item.id ? item : hw)
    },
    removeClass(state, id) {
      state.classes = state.classes.filter(item => item.id !== id)
    },
    addTemplate(state, item) {
      let sameItem = state.teacherTemplates.find(hw => hw.id === item.id)

      !sameItem ? state.teacherTemplates.push(item)
                : state.teacherTemplates = state.teacherTemplates.map(hw => hw.id === item.id ? item : hw)
    },
    deleteTemplate(state, item) {
      state.teacherTemplates = state.teacherTemplates.filter(hw => hw.id !== item.id)
    },
    updateStudent(state, student) {
      let sameItem = state.students.find(item => item.id === student.id)

      if (sameItem) {
        state.students = state.students.map(item => item.id === student.id ? student : item)
      } else {
        state.students.unshift(student)
      }   
    }
  },
  actions: {
    getClasses(ctx, id) {
      http.post('onGetClasses', { id }).then(res => {
        let classes = res.data
        ctx.commit('setClasses', classes);
      })
      .catch(e => swal('Что-то пошло не так', '' + e, 'error'))     
    },
    getStudents(ctx, id) {
      http.post('onGetStudents', {teacher_id: id})
        .then(res => {
          let students = res.data
          ctx.commit('setStudents', students);
          console.log(students)
        })
        .catch(e => swal('Что-то пошло не так', '' + e, 'error')) 
    },
    async getHomework(ctx, id) {
      let homework = await http.post('onGetTeacherHomeworks', {class_id: id}).then(res => res.data)
        
      let ordered = Object.fromEntries(Object.entries(homework).sort((a, b) => {
        let date1 = a[0].split('-').reverse().join('-')
        let date2 = b[0].split('-').reverse().join('-')

        return new Date(date1) - new Date(date2)
      }))  
      ctx.commit('setTeacherHomework', ordered);
    },
    async getTemplates(ctx, id) {
      let templates = await http.post('onGetAHTemplates', {class_id: id}).then(res => res.data)
      ctx.commit('setTeacherTemplates', templates);
    },
    postClass(ctx, data) {
      http.post('onAddClass', data).then((res) => {
        swal('Успешно!', 'Класс создан', 'success')
        ctx.commit('addClass', res.data.class)
      })      
    }
  },
  getters: {
    classes(state) {
      return state.classes
    },
    students(state) {
      return state.students
    },
    homework(state) {
      return state.teacherHomework
    },
    templates(state) {
      return state.teacherTemplates
    },
    studentById(state) {
      return (id) => {
        return state.students.find(item => item.id === +id)
      }
    }
  }
}